import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

const Privacy: FC = () => {
  const { t } = useTranslation();

  return (
    <main className="overflow-y-auto px-4 pb-4 pt-[3.75rem] text-white/40">
      <h1 className="text-xl leading-none font-normal mb-4">
        {t('Privacy Policy')}
      </h1>
      <p className="text-sm mb-4">
        {t(
          'At Star Industry, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and share your information when you use our game, which operates as a Telegram Mini App',
        )}
      </p>
      <ol className="w-full flex flex-col gap-4 p-0 m-0 text-sm font-norma list-inside !list-decimal">
        <li>
          <div className="inline-block">{t('Information We Collect')}</div>
          <div>{t('We may collect the following types of information:')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                "Personal Information: When you sign in to Star Industry via Telegram, we may access basic information associated with your Telegram account, such as your username, user ID, and profile photo. This is done in accordance with Telegram's terms and policies.",
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Usage Data: We collect information on how you interact with the game, including gameplay behavior, device details, in-game purchases, and activity within the app.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Cookies and Similar Technologies: We use cookies and similar technologies to enhance your experience, track user activity, and analyze performance. These technologies help us improve the game and ensure its proper functioning.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('How We Use Your Information')}</div>
          <div>{t('We use your information for the following purposes:')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'To operate and provide the game: Your data helps us deliver the best possible gaming experience, including in-game purchases and rewards.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                "To communicate with you: We may send you in-app messages, game updates, and promotional content via Telegram's messaging system, subject to your preferences.",
              )}
            </li>
            <li className="!list-disc">
              {t(
                'To analyze game performance: We track how players interact with the game to improve features and optimize performance.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'To maintain security: We monitor user activity to prevent fraudulent behavior and protect the integrity of the game.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">
            {t('How We Share Your Information')}
          </div>
          <div>
            {t(
              'We will not sell, rent, or trade your personal data to third parties. However, we may share your data in the following circumstances:',
            )}
          </div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                "With Telegram: We rely on Telegram's platform for authentication and communication. We may share your information with Telegram for the purpose of logging into the game or sending updates.",
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Third-Party Service Providers: We may use external services to help with the development, maintenance, and improvement of the game. These third parties may have access to your data to the extent necessary to perform their functions.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Legal Compliance: If required by law, we may share your data to comply with legal processes or protect the rights, property, and safety of Star Industry, its users, or others.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Data Security')}</div>
          <div>
            {t(
              "We take reasonable measures to protect your data from unauthorized access, alteration, or deletion. However, as the game operates within the Telegram platform, it is also subject to Telegram's own security protocols and limitations. We cannot guarantee complete security due to the nature of online services.",
            )}
          </div>
        </li>
        <li>
          <div className="inline-block">{t('Your Rights')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'Access: You may request access to the data we have collected about you.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Modification: You can update or correct your personal information within the game settings or by contacting us.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Deletion: You may request that your data be deleted in accordance with the applicable laws. Note that deleting your account may impact your access to the game.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Opt-Out: You can opt-out of receiving promotional messages from us, but you will still receive essential updates regarding the game.',
              )}
            </li>
          </ul>
          <div>
            {t(
              'For any of these requests, please contact us at [Insert Contact Information]',
            )}
          </div>
        </li>
        <li>
          <div className="inline-block">{t("Children's Privacy")}</div>
          <div>
            {t(
              'Our game is not intended for children under the age of [Insert Minimum Age]. We do not knowingly collect personal information from children. If we discover that a child under the required age has provided us with personal data, we will take immediate steps to delete that information.',
            )}
          </div>
        </li>
        <li>
          <div className="inline-block">
            {t('Changes to This Privacy Policy')}
          </div>
          <div>
            {t(
              'We may update this Privacy Policy periodically to reflect changes in our practices or to comply with new legal requirements. When we make changes, the updated policy will be posted on this page with the new effective date.',
            )}
          </div>
        </li>
        <li>
          <div className="inline-block">{t('Contact Information')}</div>
          <div>
            {t(
              'If you have any questions or concerns regarding this Privacy Policy or how your data is handled, please contact us at [Insert Contact Information].',
            )}
          </div>
        </li>
      </ol>
      <p className="text-sm mt-4">
        {t(
          'By playing Star Industry, you acknowledge that you have read, understood, and agreed to these Terms of Use.',
        )}
      </p>
    </main>
  );
};

export { Privacy };
